import { useMemo } from 'react'
import { useCartStore } from '../state/cartStore'
import { computeTotals } from '../services/pricingService'

export function useCart() {
  const items = useCartStore((s) => s.items)
  const totals = useMemo(() => computeTotals(items), [items])
  return { items, totals }
}

export function useCartCount() {
  return useCartStore((s) => s.items.reduce((n, it) => n + it.qty, 0))
}
